module.exports = __webpack_public_path__ + "img/MTABAPPABI.73e794be.jpg";